import {
  Box,
  CircularProgress,
  Dialog,
  Skeleton,
  SkeletonProps,
  Stack,
} from "@mui/material";
import { ScreenTitle } from "../Typography";

export function BaseSkeleton({ sx, ...rest }: SkeletonProps) {
  return (
    <Skeleton
      {...rest}
      sx={{
        ...(sx || {}),
        // NOTE: Light/Action/Hover (4p)
        backgroundColor: "rgb(0 0 0 / 0.04)",
        borderRadius: 4,
      }}
    />
  );
}

export function TableSkeleton() {
  return (
    <Box sx={{ position: "relative" }}>
      <BaseSkeleton variant="rectangular" height={400} />;
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress size={40} />
      </Box>
    </Box>
  );
}

export function TitleSkeleton({ width }: { width?: number }) {
  return (
    <ScreenTitle>
      <BaseSkeleton variant="text" width={width || 200} />
    </ScreenTitle>
  );
}

export function CardSkeleton({ height }: { height?: number }) {
  return (
    <BaseSkeleton
      variant="rectangular"
      height={height || 120}
      animation="wave"
    />
  );
}

export function ContentSkeleton() {
  return (
    <Stack spacing={4}>
      <TitleSkeleton />
      <TableSkeleton />
    </Stack>
  );
}

export function ListSkeleton() {
  return (
    <>
      <TitleSkeleton />
      <Stack marginTop={4} maxWidth={600} marginX="auto" spacing={4}>
        <TitleSkeleton />
        <CardSkeleton />

        <TitleSkeleton />
        <CardSkeleton />

        <TitleSkeleton />
        <CardSkeleton />
      </Stack>
    </>
  );
}

export function DialogSkeleton() {
  return (
    <Dialog open>
      <CardSkeleton />
    </Dialog>
  );
}

export function IconSkeleton({ size }: { size?: number }) {
  return (
    <Skeleton
      variant="circular"
      width={size || 40}
      height={size || 40}
      sx={{
        backgroundColor: "rgb(0 0 0 / 0.04)",
        borderRadius: "50%",
      }}
    />
  );
}
